export default "__VITE_ASSET__7331f537__"